/*
  Desktop-only collapse for the vertical filter sidebar.

  Kept entirely separate from facets.js so stock filtering/sorting behaviour is untouched: this
  only toggles a class on the .facets-vertical wrapper and reads a width from the sidebar.

  Both the wrapper and the sort-bar toggle live outside the nodes facets.js replaces
  (#ProductGridContainer, .active-facets-desktop, .sorting), so the open/closed state survives
  filter and sort updates without needing to be re-bound.
*/
(() => {
  const DESKTOP_QUERY = '(min-width: 990px)';
  const COLLAPSED_CLASS = 'facets-vertical--collapsible--collapsed';

  const init = () => {
    const wrapper = document.querySelector('.facets-vertical--collapsible');
    const toggle = document.querySelector('.facets-toggle');
    const sidebar = wrapper?.querySelector('.facets-wrapper');
    if (!wrapper || !toggle || !sidebar) return;

    const desktop = window.matchMedia(DESKTOP_QUERY);

    const setCollapsed = (collapsed) => {
      if (collapsed) {
        
        wrapper.style.setProperty('--facets-collapse-offset', `${sidebar.offsetWidth}px`);
      }
      wrapper.classList.toggle(COLLAPSED_CLASS, collapsed);
      toggle.setAttribute('aria-expanded', String(!collapsed));
    };

    toggle.addEventListener('click', () => {
      if (!desktop.matches) return;
      setCollapsed(!wrapper.classList.contains(COLLAPSED_CLASS));
    });

    
    desktop.addEventListener('change', (event) => {
      if (!event.matches) setCollapsed(false);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
